import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import OrderInfo from "../components/Order/OrderInfo";
import OrderSide from "../components/Order/OrderSide";
import OrderSumry from "../components/Order/OrderSumry";
import { useParams } from "react-router-dom";
import { fetchApi, sendApi } from "../apis/Index";
import { toast } from "react-hot-toast";
import { ToastContainer } from "react-toastify";

const OrderIndex = () => {
  const { orderId } = useParams();
  const [side, setSide] = useState(false);
  const [orderItem, setOrderItem] = useState([]);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const profileApi = "https://wittynailtip.com/backend/profile.php";
    async function fetchData() {
      try {
        const result = await fetchApi(profileApi);
        if (result.data.status) {
          setUser(result.data.data);
        } else {
          console.log(result.data.message);
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchData();
  }, []);

  useEffect(() => {
    const order = { order_id: orderId };
    const orderApi = "https://wittynailtip.com/backend/order-info.php";
    async function fetchData() {
      try {
        const result = await sendApi(order, orderApi);
        if (result.data.success) {
          setOrderItem(result.data.order);
        } else {
          toast.error(result.data.message);
        }
      } catch (error) {
        toast.error(error);
      }
    }
    fetchData();
  }, []);

  return (
    <div className="w-full md:flex justify-start items-start overflow-x-hidden font-jost bg-gray-50 min-h-screen pb-10">
      <ToastContainer position="bottom-center" autoClose={2000} />
      <div className="px-4 h-16 flex justify-between items-center lg:hidden bg-white shadow-sm border-b border-gray-100">
        <div className="cursor-pointer p-2 flex flex-col gap-1.5" onClick={() => setSide(!side)}>
          <div className="w-6 h-0.5 bg-gray-800 rounded-full"></div>
          <div className="w-4 h-0.5 bg-[#FFB7CF] rounded-full ml-1"></div>
        </div>
        <div className="profile-image w-10 h-10 bg-gray-200 rounded-full overflow-hidden border-2 border-white shadow-sm">
          <img src="/logo.webp" alt="profile" className="w-full h-full object-cover" />
        </div>
      </div>
      <div className="hidden lg:block">
        <Sidebar open={true} />
      </div>
      <div className="">
        <Sidebar open={side} />
      </div>
      <div className="relative z-[40] w-full md:py-10 py-6 px-4 md:px-8 mx-auto lg:ml-[25%] max-w-7xl">
        <div className="w-full space-y-6">
          <div className="order-head flex justify-between items-center bg-white p-6 rounded-3xl shadow-sm mb-6">
            <div className="relative">
              <div className="id flex flex-col md:flex-row md:items-center gap-2 md:gap-4 font-bold">
                <h3 className="md:text-2xl text-xl text-gray-900">
                  Order <span className="text-[#FFB7CF]">#{orderItem?.order_id || "..."}</span>
                </h3>
                <h5 className="uppercase text-[#FFB7CF] tracking-wide px-3 py-1 text-xs font-semibold bg-[#fff1f5] rounded-full w-fit">
                  {orderItem?.tracking || "Processing"}
                </h5>
              </div>
              <div className="flex flex-col md:flex-row md:items-center gap-4 mt-2">
                <p className="font-medium md:text-sm text-xs text-gray-500 flex items-center gap-2">
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path></svg>
                  {orderItem?.order_date || "Loading date..."}
                </p>
                
                {orderItem?.track_id && (
                  <div className="flex items-center gap-2 px-3 py-1.5 bg-[#E1F7EB] text-[#20AA5F] rounded-lg border border-[#20AA5F]/20 text-xs font-semibold">
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path></svg>
                    <span className="uppercase">{orderItem.shipping_service}: {orderItem.track_id}</span>
                  </div>
                )}
              </div>
            </div>
          </div>
          
          <div className="w-full lg:w-[95%] xl:w-[90%] h-full block lg:flex justify-between items-start gap-x-8 space-y-6 lg:space-y-0">
            <div className="w-full lg:w-[65%] space-y-6">
              <div className="bg-white rounded-3xl shadow-sm p-2 overflow-hidden border border-gray-100">
                <OrderInfo ordered={orderItem} />
              </div>
              <div className="bg-white rounded-3xl shadow-sm p-2 overflow-hidden border border-gray-100">
                <OrderSumry ordered={orderItem} user={user} />
              </div>
            </div>
            <div className="w-full lg:w-[35%] lg:sticky lg:top-10 space-y-6">
              <div className="bg-white rounded-3xl shadow-sm p-2 overflow-hidden border border-gray-100">
                <OrderSide user={user} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderIndex;
